import React, { useState } from 'react';
import activeWishListIcon from "../../images/icons/inWishList.png";
import wishListIcon from "../../images/icons/wishlist.png";
import { Global } from '../../Variables/Global';
import { Link, Navigate, useParams } from "react-router-dom";
import { useEffect } from 'react';



const Product = (props) => {

    const image1 = props.product?.DefaultVariation?.Image1;
    const image2 = props.product?.DefaultVariation?.Image2;

    const mainImage = image1 || image2; // Image2 fallback if Image1 is null/empty

    return (
        <div className="col-6 col-md-4" key={props.itemkey}>
            <div className="item position-relative">
                <div className="imgBox" style={{ position: "relative" }}>
                    {props.product.DefaultVariation.Image2 === "" ? (
                        <Link
                            to={
                                "/DetailedProduct/" +
                                props.product.ProductName.replace(/ /g, "-") +
                                "/" +
                                props.product.ProductId +
                                "/" +
                                props.product.DefaultVariation.ProductVariationId
                            }
                        >
                            <img
                                src={Global.PHOTO_URL + props.product.DefaultVariation.Image1}
                                alt={props.product.ProductName}
                            />

                            {/* Out of Stock Overlay */}
                            {!props.product.InStock && (
                                <div className="out-of-stock-overlay">Out of Stock</div>
                            )}

                            {/* Pre-order Overlay */}
                            {props.product.IsPreOrder === true && (
                                <div
                                    className="preorder-flag"
                                    style={{
                                        position: "absolute",
                                        top: "8px",
                                        left: "8px",
                                        backgroundColor: "rgba(255, 0, 0, 0.85)",
                                        color: "white",
                                        padding: "2px 8px",
                                        borderRadius: "4px",
                                        fontSize: "12px",
                                        fontWeight: "bold",
                                    }}
                                >
                                    Pre-order
                                </div>
                            )}
                        </Link>
                    ) : (
                        <Link
                            to={
                                "/DetailedProduct/" +
                                props.product.ProductName.replace(/ /g, "-") +
                                "/" +
                                props.product.ProductId +
                                "/" +
                                props.product.DefaultVariation.ProductVariationId
                            }
                        >
                            <img
                                src={mainImage ? Global.PHOTO_URL + mainImage : "/images/placeholder.png"}
                                alt={props.product.ProductName}
                                onMouseOver={(e) => {
                                    if (image1 && image2) {
                                        e.currentTarget.src = Global.PHOTO_URL + image2;
                                    }
                                }}
                                onMouseOut={(e) => {
                                    if (image1 && image2) {
                                        e.currentTarget.src = Global.PHOTO_URL + image1;
                                    }
                                }}
                                onError={(e) => {
                                    e.currentTarget.src = "/images/placeholder.png";
                                }}
                            />

                            {/* Out of Stock Overlay */}
                            {!props.product.InStock && (
                                <div className="out-of-stock-overlay">Out of Stock</div>
                            )}

                            {/* Pre-order Overlay */}
                            {props.product.IsPreOrder === true && (
                                <div
                                    className="preorder-flag"
                                    style={{
                                        position: "absolute",
                                        top: "8px",
                                        left: "8px",
                                        backgroundColor: "rgba(255, 0, 0, 0.85)",
                                        color: "white",
                                        padding: "2px 8px",
                                        borderRadius: "4px",
                                        fontSize: "12px",
                                        fontWeight: "bold",
                                    }}
                                >
                                    Pre-order
                                </div>
                            )}
                        </Link>
                    )}
                </div>

                {/* Wishlist button */}
                {
                    props.WishListItems.find(obj => obj.ProductId === props.product.ProductId) ? (
                        <button className="btnWishList" onClick={() => props.HandleRemoveFromWishList(props.product.ProductId)}>
                            <img src={activeWishListIcon} alt="In WishList" />
                        </button>
                    ) : (
                        <button className="btnWishList" onClick={() => props.HandleAddToWishList(props.product.ProductId, props.product.DefaultVariation.ProductVariationId)}>
                            <img src={wishListIcon} alt="WishList" />
                        </button>
                    )
                }

                <div className="content">
                    {/* Product name */}
                    <Link to={"/DetailedProduct/" + props.product.ProductName.replace(/ /g, "-") + "/" + props.product.ProductId + "/" + props.product.DefaultVariation.ProductVariationId}>
                        <h5>{props.product.ProductName}</h5>
                    </Link>

                    {/* Price and add to cart */}
                    {
                        <>
                            {props.product.DefaultVariation.SalePrice === 0 || props.product.IsPreOrder ? (
                                <div>
                                    <div>
                                        <p className="pricenormal" style={{ minHeight: '40px' }}>
                                            ${props.product.DefaultVariation.RegularPrice}

                                            {/* Show preorder note if product is preorder */}
                                            {props.product.IsPreOrder === true && (
                                                <span
                                                    style={{
                                                        display: "block",
                                                        fontSize: "12px",
                                                        fontStyle: "italic",
                                                        color: "red",
                                                        marginTop: "4px"
                                                    }}
                                                >
                                                    Down payment
                                                </span>
                                            )}
                                        </p>
                                    </div>
                                    <div className="text-center">
                                        <Link to={"/DetailedProduct/" + props.product.ProductName.replace(/ /g, "-") + "/" + props.product.ProductId + "/" + props.product.DefaultVariation.ProductVariationId}>
                                            <span className="btn btn-default choose-selection-button">Add to cart</span>
                                        </Link>
                                    </div>
                                </div>
                            ) : (
                                <>
                                    {!props.product.IsPreOrder && <p className="price m-0">
                                        ${props.product.DefaultVariation.SalePrice}{" "}
                                    </p>}
                                    {!props.product.IsPreOrder && <p className="price" style={{ minHeight: '50px' }}>
                                        <span className="off">-{props.product.DefaultVariation.Percentage.toFixed(2) + "%"}</span>
                                        <span className="was"><span className="fw-medium">Was:</span> <strike>${props.product.DefaultVariation.RegularPrice}</strike></span>
                                    </p>}
                                    <div className="text-center">
                                        <Link to={"/DetailedProduct/" + props.product.ProductName.replace(/ /g, "-") + "/" + props.product.ProductId + "/" + props.product.DefaultVariation.ProductVariationId}>
                                            <span className="btn btn-default choose-selection-button">Add to cart</span>
                                        </Link>
                                    </div>
                                </>
                            )}
                        </>
                    }
                </div>
            </div>
        </div>
    );
}



export default Product;